import { ChangeDetectorRef, Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProjectsFacade, nonNegativeValidator } from '@piqet-angular/data';
import { AccessPermissionService, CustomModalService } from '@piqet-angular/shared';
import { ActionButtonComponent } from '../action-button/action-button.component';
import { InlineActionButtonComponent } from '../inline-action-button/inline-action-button.component';
import { ProjectsService } from 'libs/data/src/lib/services/projects/projects.service';
import { ProductIngredientDataGridService } from 'libs/features/src/lib/layout/projects/product-details/product-ingredients/product-ingredient-data-grid.service';
import { Subscription, lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'piqet-angular-add-product-use',
  templateUrl: './add-product-use.component.html',
  styleUrls: ['./add-product-use.component.scss'],
})
export class AddProductUseComponent {
  prodUseForm!: FormGroup;
  modalLabel: any;
  isCustomProcess: boolean = false;
  isCostTrunOff: any = true;
  manufactureItems: any;
  submitForManufacture: boolean = false;
  manufactureColumnDef: any;
  manufactureColumnDefForCost: any;
  manufactureItemsCustom: any;
  energyProcessItems: any;
  manufactureGridData: any = [];
  activatedRoute: any;
  deleteObs!: Subscription;
  productId: any;
  manufactureProcessData: any;
  isProcessDuplicate: boolean = false;
  editProductManufactureSubscription!: Subscription;
  deleteProductManufactureSubscription!: Subscription;
  editManufactureData: any;
  manufactureEditMode: boolean = false;
  frameworkComponents = {
    inlineActionButtonComponent: InlineActionButtonComponent,
    actionRenderer: ActionButtonComponent,
  };
  showEdit: boolean = false;
  @Output() saveProdUse = new EventEmitter<{}>();

  constructor(
    private modal: CustomModalService,
    private fb: FormBuilder,
    public projectFacade: ProjectsFacade,
    private projectsService: ProjectsService,
    private productIngredientDataGridService: ProductIngredientDataGridService,
    private toaster: ToastrService,
    private cdr: ChangeDetectorRef,
    private accessService: AccessPermissionService
  ) {}

  ngOnInit() {
    this.activatedRoute = 'product-use';
    this.showEdit = this.accessService.hasPermission('edit', this.activatedRoute);
    let modalData = this.modal?.modalService?.config?.initialState;
    this.modalLabel = modalData?.['label'];
    this.manufactureItems = modalData?.['manufacturingList'];
    this.energyProcessItems = modalData?.['manufacturingList'];
    this.manufactureItemsCustom = modalData?.['fillingList'];
    this.isCostTrunOff = !modalData?.['isCostTrunOff'];
    this.productId = modalData?.['prodId'];
    this.manufactureGridData = modalData?.['productUseGridData'];

    this.prodUseForm = this.fb.group({
      processName: [null, Validators.required],
      amount: ['', [Validators.required, nonNegativeValidator, Validators.maxLength(100)]],
      costPerUnit: [0],
      costPerPackage: [0],
    });

    this.deleteObs = this.productIngredientDataGridService.deleteProdUseRowObs$.subscribe(
      (data: any) => {
        this.deleteRow(data);
      }
    );
    this.editProductManufactureSubscription =
      this.productIngredientDataGridService.editProductManufactureSub$.subscribe(
        editManufactureData => {
          this.manufactureEditMode = true;
          this.editManufactureData = editManufactureData.data;
          this.bindManufactureForm(editManufactureData.data, editManufactureData.isCostOn);
        }
      );

    this.deleteProductManufactureSubscription =
      this.productIngredientDataGridService.deleteProductManufactureSub$.subscribe(
        editManufactureData => {
          this.projectFacade.proudctIngredientManufactureProcess(editManufactureData, 'delete');
          this.prodUseForm.controls['processName'].setValue(null);
          this.prodUseForm.controls['amount'].setValue('');
          this.prodUseForm.controls['costPerPackage'].setValue(0);
          this.prodUseForm.controls['costPerUnit']?.setValue(0);
          this.manufactureEditMode = false;
        }
      );
    this.manufactureColumnDefForCost =
      this.productIngredientDataGridService.newProductIngredientManactureColumnsForCost(
        this.activatedRoute
      );
    this.manufactureColumnDef =
      this.productIngredientDataGridService.newProductIngredientManactureColumns(
        this.activatedRoute
      );
  }

  bindManufactureForm(data: any, isCostOn: any) {
    this.isCustomProcess = data.isCustomFilling;
    this.manufactureItems = data.isCustomFilling
      ? this.manufactureItemsCustom
      : this.energyProcessItems;
    const id = data.isCustomFilling ? data.customFillingId : data?.energyProcessId;
    this.manufactureItems.filter((item: any) => {
      if (Number(id) === (data.isCustomFilling ? Number(item.idStr) : item.id)) {
        if (!isCostOn) {
          this.prodUseForm.patchValue({ processName: item, amount: data?.amount });
        } else {
          this.prodUseForm.patchValue({
            processName: item,
            amount: data?.amount,
            costPerUnit: data.costPerUnit,
            costPerPackage: data.costPerPackage,
          });
        }
      }
    });
  }
  onClose() {
    this.modal.close();
  }

  async onSave() {
    if (this.manufactureGridData.length) {
      let response = await lastValueFrom(
        this.projectsService.saveProdUseData(this.manufactureGridData)
      );
      !response.messageType
        ? this.toaster.success(response.message)
        : this.toaster.error(response.message);
      this.modal.close();
      this.saveProdUse.emit();
    }
  }

  getCustomFillingList() {
    this.projectsService.getCustomFillingList().subscribe((res: any) => {
      this.manufactureItems = res.data;
      this.manufactureItemsCustom = res.data;
    });
  }

  commonInputSearchForDes(term: string, item: any) {
    return item.description.toLowerCase().includes(term.toLowerCase());
  }

  commonInputSearchForName(term: string, item: any) {
    return item.name.toLowerCase().includes(term.toLowerCase());
  }

  getCostPerPackage() {
    const amount = this.prodUseForm.controls['amount']?.value || 0;
    const costPerUnit = this.prodUseForm.controls['costPerUnit']?.value || 0;
    const result = (amount * costPerUnit) / 1000;
    this.prodUseForm.controls['costPerPackage'].setValue(result);
  }

  addProcess() {
    this.submitForManufacture = true;
    if (this.prodUseForm.valid) {
      const payload: any = {};
      payload['productId'] = this.productId;
      payload['fillingProcessName'] = this.prodUseForm.controls['processName'].value.name;
      payload['amount'] = Number(this.prodUseForm.controls['amount'].value);
      payload['costPerUnit'] = this.prodUseForm.controls['costPerUnit']?.value;
      payload['costPerPackage'] = this.prodUseForm.controls['costPerPackage']?.value;
      payload['isCustomFilling'] = this.isCustomProcess;
      if (this.manufactureEditMode) {
        payload['index'] = this.editManufactureData.index;
      }
      this.isCustomProcess
        ? (payload['customFillingId'] = this.prodUseForm.value.processName?.idStr)
        : (payload['energyProcessId'] = this.prodUseForm.value.processName?.id);
      const gridData = this.generateRow(payload, this.manufactureEditMode ? 'edit' : 'add');
      this.manufactureGridData = gridData;
      this.cdr.detectChanges();
      this.submitForManufacture = false;
      this.prodUseForm.controls['processName'].setValue(null);
      this.prodUseForm.controls['amount'].setValue('');
      this.prodUseForm.controls['amount'].markAsUntouched();
      this.prodUseForm.controls['costPerPackage'].setValue(0);
      this.prodUseForm.controls['costPerUnit']?.setValue(0);
      this.manufactureEditMode = false;
    }
  }

  generateRow(data: any, type: any) {
    let gridRecord = [...this.manufactureGridData];

    if (type === 'add') {
      if (data) {
        // Check for duplicate energyProcessId
        const isDuplicate = gridRecord.some(
          item => !data.isCustomFilling && item.energyProcessId === data.energyProcessId
        );

        if (isDuplicate) {
          this.isProcessDuplicate = true;
          return gridRecord;
        }
        this.isProcessDuplicate = false;
        gridRecord = [...gridRecord, { ...data, index: gridRecord.length + 1 }];
      }
    } else if (type === 'edit') {
      const index = gridRecord.findIndex(item => item.index === data.index);
      if (index !== -1) {
        // Check for duplicate energyProcessId, excluding the current row being edited
        const isDuplicate = gridRecord.some(
          (item, idx) =>
            idx !== index && !data.isCustomFilling && item.energyProcessId === data.energyProcessId
        );

        if (isDuplicate) {
          this.toaster.warning('This process has already been added.');
          return gridRecord;
        }

        gridRecord[index] = { ...data };
      }
    } else if (type === 'delete') {
      gridRecord = gridRecord.filter(item => item.index !== data.index);
      gridRecord = this.deleteCustomProcess(gridRecord);
    }

    return gridRecord;
  }

  deleteCustomProcess(type: any) {
    return type.map((item: any, i: any) => {
      return {
        ...item,
        index: item.id == 0 || !item.hasOwnProperty('ingredientId') ? i + 1 : item.ingredientId,
      };
    });
  }

  deleteRow(data: any) {
    const gridData = this.generateRow(data, 'delete');
    this.manufactureGridData = gridData;
    this.submitForManufacture = false;
    this.prodUseForm.controls['processName'].setValue(null);
    this.prodUseForm.controls['amount'].setValue('');
    this.prodUseForm.controls['costPerPackage'].setValue(0);
    this.prodUseForm.controls['costPerUnit']?.setValue(0);
  }

  changeMaterialValue(data: any) {
    this.isCustomProcess = data.target.checked ? true : false;
    if (this.isCustomProcess) {
      this.prodUseForm.controls['amount'].clearValidators();
    } else {
      this.prodUseForm.controls['amount'].setValidators([Validators.required]);
    }
    this.manufactureItems = this.isCustomProcess
      ? this.manufactureItemsCustom
      : this.energyProcessItems;
    this.prodUseForm.controls['processName'].setValue(null);
    this.prodUseForm.controls['amount'].setValue('');
    this.prodUseForm.controls['costPerPackage'].setValue(0);
    this.prodUseForm.controls['costPerUnit'].setValue(0);
  }

  ngOnDestroy() {
    this.deleteObs.unsubscribe();
    this.editProductManufactureSubscription.unsubscribe();
  }
}
